module.exports = {"533124101":"章凤镇","533124102":"陇把镇","533124103":"景罕镇","533124104":"城子镇","533124201":"户撒阿昌族乡","533124202":"护国乡","533124203":"清平乡","533124204":"王子树乡","533124205":"勐约乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533124.json
// module id = 2664
// module chunks = 0